import { render, staticRenderFns } from "./WeeklyProjectionApproval.vue?vue&type=template&id=121c833e&scoped=true"
import script from "./WeeklyProjectionApproval.vue?vue&type=script&lang=js"
export * from "./WeeklyProjectionApproval.vue?vue&type=script&lang=js"
import style0 from "./WeeklyProjectionApproval.vue?vue&type=style&index=0&id=121c833e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121c833e",
  null
  
)

export default component.exports